import Immutable from "immutable";

export const currentHeatsSelector = (
    { events },
    {
        match: {
            params: { id },
        },
    },
) =>
    events
        .getIn(["current_heats", id, "heats"], Immutable.List())
        .map((heatId) => events.getIn(["heats", id, heatId]));
export const schedulePositionSelector = (
    { events },
    {
        match: {
            params: { id },
        },
    },
) => events.getIn(["current_heats", id, "current_schedule_index"], 0);
export const eventSelector = (
    { events },
    {
        match: {
            params: { id },
        },
    },
) => events.getIn(["mini", parseInt(id)], Immutable.Map());
export const heatsLoadedSelector = (
    { events },
    {
        match: {
            params: { id },
        },
    },
) => events.getIn(["current_heats", id, "heats"]);
